import moment from 'moment';
import React, { Component, createRef } from 'react';
import {
  FaCheck,
  FaCheckCircle,
  FaExclamationCircle,
  FaPencilAlt,
  FaSortDown,
  FaSpinner,
  FaTimes,
  FaTrash,
  FaExclamationTriangle
} from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import api from '../../../axios-local-api';
import Confirm from '../../../components/UI/Confirm/Confirm';
import DeviceBusyness from '../../../components/UI/DeviceHistory/DeviceBusyness';
import DeviceOnlineStatus from '../../../components/UI/DeviceHistory/DeviceOnlineStatus';
import RSSIAlarmHistory from '../../../components/UI/DeviceHistory/RSSIAlarmHistory';
import DeviceIcon from '../../../components/UI/DeviceIcon/DeviceIcon';
import Error from '../../../components/UI/Error/Error';
import Modal from '../../../components/UI/Modal/Modal';
import RSSI from '../../../components/UI/RSSI/RSSI';
import Spinner from '../../../components/UI/Spinner/Spinner';
import AlarmsSummary from '../../../components/UI/Steering/AlarmsSummary';
import Steering from '../../../components/UI/Steering/Steering';
import SteeringEvents from '../../../components/UI/Steering/SteeringEvents';
import Success from '../../../components/UI/Success/Success';
import Switch from '../../../components/UI/Switch/Switch';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../../store/actions/index';
import PauseScheduleLink from '../PauseScheduleLink/PauseScheduleLink';
import ReportADIDIssuesForm from '../ReportADIDIssuesForm/ReportADIDIssuesForm';
import classes from './DeviceDetails.css';
import DeviceSteeringtwoFour from './DeviceSteeringto2.4';
import DeviceSterringCountDownTimer from '../../DeviceSteering/DeviceSterringCountDownTimer/DeviceSterringCountDownTimer';
import QOE from '../../QOE/QOE';
import { EquipmentTypes } from '../../../shared/common';
import SelectDropdown from '../../../shared/SelectDropdown/SelectDropdown';


export class DeviceDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditDevName: false,
      saveDeviceBtn: false,
      freezeIsLoaded: false,
      customEnabled: null,
      customTemp: null,
      untilMidnightEnabled: null,
      foreverEnabled: null,
      upArrow: false,
      success: false,
      error: false,
      action: '',
      result: null,
      showDropDownList: false,
      showIconSelect: false,
      confirmModal: false,
      deviceIcon: this.props.originalDevice?.deviceIconReference
        ? this.props.originalDevice.deviceIconReference
        : undefined,
      checked: this.props.originalDevice?.freeze?.frozen ? true : false,
      originalDevice: this.props.originalDevice,
      days: '1',
      alarms15: null,
      alarms24: null,
      alarms30: null,
      alarms7: null,
      warnings15: null,
      warnings24: null,
      warnings30: null,
      warnings7: null,
      rssiData1Day: null,
      rssiData7Day: null,
      bandSteering1Day: null,
      bandSteering7Day: null,
      mappedTransmitted: null,
      showADIDIssuesForm: false,
      deviceNicknameWarning: null,
      controls: {
        deviceName: {
          elementType: 'input',
          elementConfig: {
            type: 'DeviceName',
            placeholder: 'Device Name',
          },
          value: this.props.isLoading ? '' : this.props.devName,
          validation: {
            required: true,
            minLength: 6,
          },
          valid: false,
          touched: false,
        },
      },
      speedBoostCheckStatus: '',
      boostFailureReason: this.props.originalDevice.boostFailureReason ?? '',
      speedBoostCheckLoading: false,
      boostDevice: this.props.originalDevice.boost ?? {},
      speedBoostDevices: [],
      featureFlags: sessionStorage.getItem('featureFlags'),
      steeringDevices: false,
      wifiSecurityMode: 'N/A',
      conflictSchedule: false,
      daysOptions: [
        { value: '1', label: 'Last 24 Hours' },
        { value: '7', label: 'Last 7 Days'},
      ],
    };
    this.dayHandler = this.dayHandler.bind(this);
    this.handleTogglePause = this.handleTogglePause.bind(this);
    this.handleDeviceScheduleEnableDisable =
      this.handleDeviceScheduleEnableDisable.bind(this);
    this.showIconSelect = this.showIconSelect.bind(this);
    this.showDropdown = this.showDropdown.bind(this);
    this.setEquipmentSelection = this.setEquipmentSelection.bind(this);
    this.dropDownRef = createRef();
    this.handleDeviceSteering = this.handleDeviceSteering.bind(this);
    // this.closeScheduleSteeringMessageModal = this.closeScheduleSteeringMessageModal.bind(this);
    this.checkScheduleConflict = this.checkScheduleConflict.bind(this);

  }

  // closeScheduleSteeringMessageModal() {
  //   this.setState({
  //     steeringDevices: false
  //   })
  // }

  toggleEditDevName = (e) => {
    this.setState({ showEditDevName: !this.state.showEditDevName });
  };

  isValidName(name) {
    // if (this.props.devName === name) {
    //   return 'The name has not been changed'
    // } else
    if (name === this.props.devName) {
      return false;
    }
    if (name.length >= 30) {
      return 'Max Character Limit Reached';
    }
    if (name.length <= 3 || name.length > 30) {
      // Prevent the input of any names longer than the allowed limit

      // The name must be at least 4 characters long
      if (name.length >= 1 && /^\s|\s{}|\s$/.test(name)) {
        return 'Space is only allowed in between the characters';
      }
      // The name must be at least 4 characters long
      if (name.length >= 1 && /\s{2,}/g.test(name)) {
        return 'Single Space is allowed in between the characters';
      }
      if (name.length >= 1 && !(/^[^<>]+$/.test(name.trim()))) {
        // Use a regex to find '<' or '>' two special characters that aren't allowed
        return 'Special Characters are not allowed <>';
      }
      return false;
    }
    // else if (/^\s|\s{2,}|\s$/.test(name)) {
    //   // Use a regex to find any of the following spacing instances in `name`
    //   // (all spaces, double spaces, preceding spaces, trailing spaces)
    //   return false;
    // }
    else if (/^\s|\s{}|\s$/.test(name)) {
      return 'Space is only allowed in between the characters';
    }
    else if (name.length >= 1 && /\s{2,}/g.test(name)) {
      return 'Space is only allowed in between the characters';
    } else if (!(/^[^<>]+$/.test(name.trim()))) {
      // Use a regex to find '<' or '>' two special characters that aren't allowed
      return 'Special Characters are not allowed <>';
    }
    // Passed all checks. The name is valid!
    return !(name === this.props.devName);
  }

  handleClickOutSide = (event) => {
    if (
      this.dropDownRef.current &&
      !this.dropDownRef.current.contains(event.target)
    ) {
      // console.log('event.target', event.target);
      this.setState({
        showDropDownList: false,
      });
    } else if (
      this.dropDownRef.current &&
      this.dropDownRef.current.contains(event.target)
    ) {
      this.showDropdown();
    }
  };

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutSide, true);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.originalDevice.freeze &&
      this.props.originalDevice.freeze.timeTemplates &&
      JSON.stringify(prevProps.originalDevice.freeze.timeTemplates) !== JSON.stringify(this.props.originalDevice.freeze.timeTemplates)
    ) {

      let cust = this.props.originalDevice.freeze.timeTemplates.find(
        (item) => {
          return item.id === 'custom';
        }
      );

      this.setState({
        customTemp: cust,
      });
      if (cust && (cust.enable === true || cust.enable === false)) {
        this.setState({
          customEnabled: cust.enable,
        });
      }

    }
  }

  componentDidMount() {
    // console.log('coming ');
    document.addEventListener('click', this.handleClickOutSide, true);
    if (
      !this.state.freezeIsLoaded &&
      this.props.originalDevice.freeze &&
      this.props.originalDevice.freeze.timeTemplates &&
      this.props.originalDevice.freeze.timeTemplates.length
    ) {
      // console.log('coming into if condition')
      let customTempHandle = new Promise((res, rej) => {
        let cust = this.props.originalDevice.freeze.timeTemplates.find(
          (item, ind, arr) => {
            return item.id === 'custom';
          }
        );
        res(cust);
      });
      // console.log('216 :::', customTempHandle)
      let untilMidnightTempHandle = new Promise((reso, reje) => {
        let midni = this.props.originalDevice.freeze.timeTemplates.find(
          (item, ind, arr) => {
            return item.id === 'untilMidnight';
          }
        );
        reso(midni);
      });
      let foreverTempHandle = new Promise((reso, reje) => {
        let forev = this.props.originalDevice.freeze.timeTemplates.find(
          (item, ind, arr) => {
            return item.id === 'forever';
          }
        );
        reso(forev);
      });

      let suspendTempHandle = this.props.originalDevice.freeze.suspended.enable;
      foreverTempHandle.then((forev) => {
        if (forev && (forev.enable === true || forev.enable === false)) {
          this.setState({
            foreverEnabled: forev.enable,
          });
        }
      });
      customTempHandle.then((cust) => {
        // console.log('216 :::', cust);
        this.setState({
          customTemp: cust,
        });
        if (cust && (cust.enable === true || cust.enable === false)) {
          this.setState({
            customEnabled: cust.enable,
          });
        }
      });
      // console.log('216 :::', this.state.customTemp);
      untilMidnightTempHandle.then((midni) => {
        if (midni && (midni.enable === true || midni.enable === false)) {
          this.setState({
            untilMidnightEnabled: midni.enable,
          });
        }
      });

      this.setState({
        freezeIsLoaded: true,
        checked: this.props.originalDevice.freeze.frozen
      });
    }

    if (this.props.originalDevice.connectionState === 'disconnected' && this.props.originalDevice.medium.includes('ethernet') ) {
      this.setState({ wifiSecurityMode: 'N/A' })
    } else {
      const devConnectedTo = this.getConnectedTo();
      let wifiSecurityMode = 'N/A';
      if (devConnectedTo === 'Router') {
        const isEthernet=this.props.originalDevice.medium.includes('ethernet');
        const freqBand = isEthernet || this.props.originalDevice.freqBand.includes('2.4G') ? '2g' : this.props.originalDevice.freqBand.toLowerCase();

        wifiSecurityMode = this.props.realSettings ? this.props.realSettings[freqBand + 'hz_wifi'].subscriber.security_mode : 'N/A'

        if (isEthernet) {
          wifiSecurityMode = 'N/A'
        }
      }
      this.setState({wifiSecurityMode })
    }
  }

  openHandler() {
    // console.log('OPEN HANDLER GO');
    this.prepareAll(
      this.props.originalDevice.advancedDevice
        ? this.props.originalDevice.advancedDevice.rssi
        : null,
      this.props.bandwidth,
      this.props.originalDevice.advancedDevice
        ? this.props.originalDevice.advancedDevice.bandSteeringStats
        : null,
      1
    );
  }
  closeHandler() {
    this.setState({
      upArrows: false,
    });
  }
  resetUpArrows() {
    this.setState({
      upArrows: false,
    });
  }
  handleDeviceNameChange = (e) => {
    const newName = e.target.value;
    const isValid = this.isValidName(newName)
    // console.log(isValid, 'isValid')
    if (isValid !== true) {
      // Invalid name
      this.setState({ deviceNicknameWarning: isValid, saveDeviceBtn: newName.length === 30 && isValid ? true : false })
    } else {
      this.setState({ deviceNicknameWarning: null, saveDeviceBtn: true })
    }
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        deviceName: {
          ...prevState.controls.deviceName,
          value: newName,
        },
      },
    }));
  };
  cancelDevName = () => {
    let devName = this.props.devName;
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        deviceName: {
          ...prevState.controls.name,
          value: devName,
        },
      },
      deviceNicknameWarning: null,
      saveDeviceBtn: false
    }));
    this.setState({ showEditDevName: !this.state.showEditDevName });
  };

  confirmModalConfirmHandler = () => {
    if (this.state.action === 'pause out of schedule') {
      this.props.onChangeFreezeDevice(
        'put',
        this.props.originalDevice.mac,
        'untilMidnight',
        { shouldPause: true },
        this.props.selectedEquipment
      );
    }
    if (this.state.action === 'pause in schedule') {
      this.props.onChangeFreezeDevice(
        'delete',
        this.props.originalDevice.mac,
        'suspend',
        { shouldPause: true },
        this.props.selectedEquipment
      );
    }
    if (this.state.action === 'unpause in schedule') {
      this.props.onChangeFreezeDevice(
        'put',
        this.props.originalDevice.mac,
        'suspend',
        { shouldPause: false },
        this.props.selectedEquipment
      );
    }
    if (this.state.action === 'unpause out of schedule') {
      this.props.onChangeFreezeDevice(
        'delete',
        this.props.originalDevice.mac,
        'untilMidnight',
        { shouldPause: false },
        this.props.selectedEquipment
      );
    }
    if (this.state.action === 'change your device name') {
      this.props.onChangeDeviceName(
        this.state.controls.deviceName.value,
        this.props.originalDevice
          ? this.props.originalDevice.deviceIconReference
          : this.props.bandwidth.deviceIconReference,
        this.props.originalDevice.mac,
        this.props.selectedEquipment
      );
    }
    if (this.state.action === 'remove this device from your network') {
      this.props.onDeleteDevice(this.props.originalDevice.mac);
      this.props.updateDeletedDevice(this.props.originalDevice.mac);
    }
    if (
      this.state.action === 'pause this device' ||
      this.state.action === 'unpause this device'
    ) {
      this.props.onChangePauseDevice(
        this.state.checked ? false : true,
        this.props.originalDevice.mac,
        this.props.selectedEquipment
      );
      this.closeModal();
    }
    if (this.state.action === 'change your device icon') {
      this.props.onChangeDeviceIcon(
        this.props.originalDevice.deviceFriendlyName
          ? this.props.originalDevice.deviceFriendlyName
          : this.props.devName,
        this.state.deviceIcon,
        this.props.originalDevice.mac,
        this.props.selectedEquipment
      );
    }

    if (this.state.action === 'scheduled pause status') {
      this.handleDeviceScheduleStatus();
      this.props.updateScheduleDetails();
    }
    this.confirmModalCancelHandler();
  };
  confirmModalCancelHandler = () => {
    // this.props.resetDevice();
    // this.props.resetUpArrows();
    //this.props.modalCancel();
    this.setState({ confirmModal: false, showEditDevName: false });
  };
  backToDeviceOverview = () => {
    this.setState({ showEditDevName: false });
  };

  closeModal = () => {
    this.setState({ confirmModal: false });
  };
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };

  showIconSelect() {
    this.setState({
      showIconSelect: true,
    });
  }

  submitDeviceNameHandler = (event) => {
    this.onOpenModal('', 'change your device name');
  };
  submitDeviceIconHandler = (e) => {
    let deviceIcon = e.target.value;
    this.setState({
      deviceIcon: deviceIcon,
    });
    this.onOpenModal('', 'change your device icon');
  };
  submitDeleteDeviceHandler = (event) => {
    this.onOpenModal('', 'remove this device from your network');
  };
  submitPauseDeviceHandler = (event) => {
    this.onOpenModal('', 'change the status of this Device');
  };
  handleTogglePause() {
    // const isDeviceSteering = this.props.originalDevice.steering ? !!Object.keys(this.props.originalDevice.steering).length : false;
    // if (isDeviceSteering) {
    //   this.setState({
    //     steeringDevices: true
    //   })
    // } else
    if (
      this.props.originalDevice.freeze &&
      !this.state.foreverEnabled &&
      this.state.customEnabled
    ) {
      let isFrozen = this.props.originalDevice.freeze.frozen;
      let isCustom = this.state.customEnabled;
      let isForever = this.state.foreverEnabled;
      let isSuspended = this.props.originalDevice.freeze.suspended.enable;
      let isUntilMidnight = this.state.untilMidnightEnabled;
      if (!isFrozen && !isSuspended && !isUntilMidnight) {
        //PAUSE out of schedule
        this.onOpenModal(
          'This will pause all internet connectivity to this device.',
          'pause out of schedule'
        );
      } else if (isFrozen && !isSuspended && isUntilMidnight) {
        //UNPAUSE out of schedule
        this.onOpenModal(
          'This will unpause all internet connectivity to this device.',
          'unpause out of schedule'
        );
      } else if (isFrozen && !isSuspended && !isUntilMidnight) {
        //UNPAUSE in schedule
        this.onOpenModal(
          'This will unpause all internet connectivity to this device.',
          'unpause in schedule'
        );
      } else if (!isFrozen && isSuspended && !isUntilMidnight) {
        //PAUSE in schedule as suspended
        this.onOpenModal(
          'This will pause all internet connectivity to this device.',
          'pause in schedule'
        );
      } else if (!isFrozen && isSuspended && isUntilMidnight) {
        this.onOpenModal(
          'This will pause all internet connectivity to this device.',
          'pause in schedule'
        );
      } else {
      }
    } else {
      if (!this.state.checked) {
        this.onOpenModal(
          'This will pause all internet connectivity to this device.',
          'pause this device'
        );
      } else {
        this.onOpenModal(
          'This will unpause all internet connectivity to this device.',
          'unpause this device'
        );
      }
    }
  }

  prepareBandSteeringSummaryTable(summary) {
    var rows = [];
    if (
      typeof summary === 'object' &&
      summary != {} &&
      Object.keys(summary).length !== 0 &&
      summary.constructor === Object
    ) {
      var value = summary.minutes15;
      rows.push([
        'Last 15 Min',
        value.bs_attempted,
        value.bs_succeeded,
        value.bs_failed,
      ]);
      value = summary.hours24;
      rows.push([
        'Last 24 Hours',
        value.bs_attempted,
        value.bs_succeeded,
        value.bs_failed,
      ]);
      value = summary.day7;
      rows.push([
        'Last 7 Days',
        value.bs_attempted,
        value.bs_succeeded,
        value.bs_failed,
      ]);
      value = summary.day30;
      rows.push([
        'Last 30 Days',
        value.bs_attempted,
        value.bs_succeeded,
        value.bs_failed,
      ]);
      return rows;
    } else {
      return rows;
    }
  }

  prepareClientSteeringSummaryTable(summary) {
    var rows = [];

    if (
      typeof summary === 'object' &&
      summary != {} &&
      Object.keys(summary).length !== 0 &&
      summary.constructor === Object
    ) {
      var value = summary.minutes15;
      rows.push([
        'Last 15 Min',
        value.cs_attempted,
        value.cs_succeeded,
        value.cs_troubled,
        value.cs_failed,
      ]);
      value = summary.hours24;
      rows.push([
        'Last 24 Hours',
        value.cs_attempted,
        value.cs_succeeded,
        value.cs_troubled,
        value.cs_failed,
      ]);
      value = summary.day7;
      rows.push([
        'Last 7 Days',
        value.cs_attempted,
        value.cs_succeeded,
        value.cs_troubled,
        value.cs_failed,
      ]);
      value = summary.day30;
      rows.push([
        'Last 30 Days',
        value.cs_attempted,
        value.cs_succeeded,
        value.cs_troubled,
        value.cs_failed,
      ]);
      return rows;
    } else {
      return rows;
    }
  }
  prepareSteeringEvents(events) {
    if (events === undefined || events.data24h === undefined) {
      return [];
    }
    return events.data24h.points;
  }
  prepareAll(rssi, busynessData, bandSteeringData, days) {
    function roundTimeQuarterHour() {
      var timeToReturn = new Date(Date.now());

      timeToReturn.setMilliseconds(
        Math.floor(timeToReturn.getMilliseconds() / 1000) * 1000
      );
      timeToReturn.setSeconds(Math.floor(timeToReturn.getSeconds() / 60) * 60);
      timeToReturn.setMinutes(Math.floor(timeToReturn.getMinutes() / 15) * 15);
      return timeToReturn.getTime();
    }
    let now15 = roundTimeQuarterHour();
    let fifteens = 7 * 24 * 4;
    let blanksArr = [];

    for (var i = 0; i <= fifteens - 1; i++) {
      let nowNow15 = now15 - 900000 * i;
      let nowNow15Obj = {
        timestamp: nowNow15,
        ts: nowNow15,
        value: 0,
      };

      blanksArr.push(nowNow15Obj);
    }
    if (blanksArr.length === fifteens) {
      if (busynessData === undefined) {
        return blanksArr;
      }

      let transmitted24 =
        busynessData &&
          busynessData.bandwidth24 &&
          busynessData.bandwidth24.transmitted &&
          busynessData.bandwidth24.transmitted.length
          ? busynessData.bandwidth24.transmitted
          : [];
      let transmitted7 =
        busynessData &&
          busynessData.bandwidth7 &&
          busynessData.bandwidth7.transmitted &&
          busynessData.bandwidth7.transmitted.length
          ? busynessData.bandwidth7.transmitted
          : [];
      let switchTransmitted =
        days === 1 || days === '1'
          ? transmitted24
          : days === 7 || days === '7'
            ? transmitted7
            : [];

      let mappedTransmitted = [...blanksArr].map((blank) => {
        switchTransmitted.forEach((trans) => {
          var d = new Date(trans.timestamp);

          if (
            d.getTime() === blank.ts &&
            trans.value !== 'null' &&
            trans.value !== null
          ) {
            blank.value = trans.value;
          }
        });
        blank.startTime = blank.timestamp;
        blank.endTime = blank.timestamp + 899999;
        blank.timestamp = new Date(blank.timestamp);
        blank.startTime = new Date(blank.startTime);
        blank.endTime = new Date(blank.endTime);

        blank.color =
          blank.value < 10
            ? 'white'
            : blank.value >= 10 && blank.value < 50
              ? 'lightgray'
              : blank.value >= 50 && blank.value < 100
                ? 'gray'
                : blank.value >= 100 && blank.value < 200
                  ? '#585858' //DARK GRAY
                  : blank.value >= 200
                    ? 'black'
                    : 'white';

        return blank;
      });
      let masterRssi = rssi['2g'].perc75
        ? rssi['2g'].perc75.concat(
          rssi['5g'].perc75 ? rssi['5g'].perc75 : [],
          rssi['5gl'].perc75 ? rssi['5gl'].perc75 : [],
          rssi['5gu'].perc75 ? rssi['5gu'].perc75 : [],
          rssi['6g'].perc75 ? rssi['6g'].perc75 : []
        )
        : [].concat(
          rssi['5g'].perc75 ? rssi['5g'].perc75 : [],
          rssi['5gl'].perc75 ? rssi['5gl'].perc75 : [],
          rssi['5gu'].perc75 ? rssi['5gu'].perc75 : [],
          rssi['6g'].perc75 ? rssi['6g'].perc75 : []
        )
      let mappedRssi = [...blanksArr].map((item) => {
        let blank = item;
        masterRssi.forEach((rssiEl) => {
          if (rssiEl.ts === blank.ts.toString() && rssiEl.value < blank.value) {
            blank = rssiEl;
          }
        });
        blank.onlineColor = blank.value === 0 ? 'white' : 'green';
        blank.alarmColor =
          blank.value === 0
            ? ''
            : blank.value < -70
              ? 'red'
              : blank.value >= -70 && blank.value <= -65
                ? 'yellow'
                : 'lightgray';

        return blank;
      });

      this.setState({
        mappedTransmitted: mappedTransmitted,
        mappedRssi: mappedRssi,
        rssiAvailable: masterRssi.length ? true : false,
        transmittedAvailable: switchTransmitted.length ? true : false,
      });

      let get15Min75 = [...masterRssi].filter((d) => {
        return new Date(d.timestamp).getTime() >= Date.now() - 900000;
      });
      let get1Day75 = [...masterRssi].filter((d) => {
        return new Date(d.timestamp).getTime() >= Date.now() - 86400000;
      });
      let get7Day75 = [...masterRssi].filter((d) => {
        return new Date(d.timestamp).getTime() >= Date.now() - 86400000 * 7;
      });

      let alarms15 = get15Min75.filter((a) => {
        return a.value < -70;
      });
      let alarms24 = get1Day75.filter((a) => {
        return a.value < -70;
      });
      let alarms7 = get7Day75.filter((a) => {
        return a.value < -70;
      });

      let alarms30 = [...masterRssi].filter((a) => {
        return a.value < -70;
      });

      let warnings15 = get15Min75.filter((a) => {
        return a.value >= -70 && a.value <= -65;
      });
      let warnings24 = get1Day75.filter((a) => {
        return a.value >= -70 && a.value <= -65;
      });
      let warnings7 = get7Day75.filter((a) => {
        return a.value >= -70 && a.value <= -65;
      });
      let warnings30 = [...masterRssi].filter((a) => {
        return a.value >= -70 && a.value <= -65;
      });

      let bandSteering7Day =
        bandSteeringData.data7d && bandSteeringData.data7d.points
          ? bandSteeringData.data7d.points
          : [];

      Promise.resolve(
        bandSteeringData.data24h && bandSteeringData.data24h.points
          ? bandSteeringData.data24h.points.filter((el) => {
            el.ts = Date.parse(el.timestamp);
            let nowDate = Date.now();
            // console.log('nowDate - el.ts', nowDate - el.ts <= 86400000);
            if (nowDate - el.ts <= 86400000) {
              return el;
            } else {
              // console.log(
              //   '(nowDate - el.ts) <= 86400000',
              //   nowDate - el.ts <= 86400000
              // );
            }
            return false;
          })
          : []
      ).then((result) => {
        // console.log('promiseres');
        this.setState({
          bandSteering1Day: result,
        });
      });

      this.setState({
        rssiData1Day: get1Day75,
        rssiData7Day: get7Day75,
        bandSteering7Day: bandSteering7Day,
        warnings15: warnings15.length,
        warnings24: warnings24.length,
        warnings30: warnings30.length,
        warnings7: warnings7.length,
        alarms15: alarms15.length,
        alarms24: alarms24.length,
        alarms30: alarms30.length,
        alarms7: alarms7.length,
      });
    }
  }

  dayHandler(e) {
    let days = e.value;
    this.setState({
      days: days,
    });
    this.prepareAll(
      this.props.originalDevice.advancedDevice
        ? this.props.originalDevice.advancedDevice.rssi
        : null,
      this.props.bandwidth,
      this.props.originalDevice.advancedDevice
        ? this.props.originalDevice.advancedDevice.bandSteeringStats
        : null,
      days
    );
  }

  getConnectedTo = () => {
    if (!this.props.originalDevice) {
      return 'N/A';
    }
    if (this.props.originalDevice.connectionState === 'disconnected') {
      return 'N/A';
    }
    if (!this.props.realWan) {
      return 'N/A';
    }
    if (this.props.originalDevice.networkId === "ABWAdditionalNetwork" && this.props.originalDevice.vapType === "fronthaul") {
      return this.props.secondSsid?.secondSsidNetwork?.ssid
    }
    let router = {
      id: this.props.realWan.id,
      mac: this.props.realWan.mac,
      //Wanted to display name as Router in the connectedTo column if the parent is Router
      nickname: 'Router',
    };
    let claimedPodMap = {};

    if (this.props.claimedPods && this.props.claimedPods.length) {
      claimedPodMap = this.props.claimedPods.reduce((acc, cpod) => {
        acc[cpod.id] = cpod;
        return acc;
      }, {});
    }
    claimedPodMap[router.id] = router;
    if (!this.props.originalDevice.leafToRoot) {
      return 'N/A';
    }
    let parent;
    if (!this.props.originalDevice.leafToRoot) {
      parent = router;
    } else {
      parent = claimedPodMap[this.props.originalDevice.leafToRoot[0].id];
    }
    if (parent === undefined) {
      parent = {}
      parent.nickname = '';
    }
    return parent.nickname || parent.defaultName;
  };
  showDropdown() {
    if (!this.state.showDropDownList) {
      this.setState({
        showDropDownList: true,
      });
    } else {
      this.setState({
        showDropDownList: false,
      });
    }
  }
  setEquipmentSelection() {
    this.props.onSetSelectedEquipment({
      displayAllEquipment: true,
      type: EquipmentTypes.Equipment,
    });
  }
  handleDeviceScheduleEnableDisable() {
    let customTemplate = this.state.customTemp;
    if (customTemplate) {
      let schedule =
        customTemplate.customSchedules && customTemplate.customSchedules.length
          ? customTemplate.customSchedules
          : undefined;
      let isDeviceSuspended = this.props.originalDevice.freeze.suspended.enable;
      if (isDeviceSuspended || !this.handleDeviceSteering({ 'customSchedules': schedule, 'enable': !this.state.customEnabled }, 'pauseLink', this.props.originalDevice.freeze.frozen)) {
        if (!this.state.customEnabled) {
          let message = (
            <Box>
              <div
                style={{
                  fontSize: '1.2rem',
                  paddingBottom: '10px',
                  fontWeight: 'bold',
                  fontFamily: 'Open Sans,serif',
                  color: '#000',
                  textAlign: 'center',
                }}
              >
                Activate A Device Pause
              </div>
              <div
                style={{
                  paddingBottom: '10px',
                  fontSize: '1.0rem',
                  fontWeight: 'normal ',
                  fontFamily: 'Open Sans,serif',
                  color: '#4e4545',
                  textAlign: 'center',
                }}
              >
                This will pause all internet connectivity to this device.
              </div>
            </Box>
          );
          this.onOpenModal(message, 'scheduled pause status');
        } else {
          let message = (
            <Box>
              <div
                style={{
                  fontSize: '1.2rem',
                  paddingBottom: '10px',
                  fontWeight: 'bold',
                  fontFamily: 'Open Sans,serif',
                  color: '#000',
                  textAlign: 'center',
                }}
              >
                Deactivate A Device Pause
              </div>
              <div
                style={{

                  paddingBottom: '10px',
                  fontSize: '1.0rem',
                  fontWeight: 'normal ',
                  fontFamily: 'Open Sans,serif',
                  color: '#4e4545',
                  textAlign: 'center',
                }}
              >
                This will unpause all internet connectivity to this device.
              </div>
            </Box>
          );
          this.onOpenModal(message, 'scheduled pause status');

        }
      }
    }
  }

  handleDeviceScheduleStatus() {
    let shouldPause;
    if (!this.state.customEnabled) {
      this.setState({
        customEnabled: true,
      });
      shouldPause = true;

      this.setState((prevState) => ({
        ...prevState,
        customTemp: {
          ...prevState.customTemp,
          ...prevState.customTemp.enable,
          enable: true,
        },
      }));
    } else {
      this.setState({
        customEnabled: false,
      });

      shouldPause = false;

      this.setState((prevState) => ({
        ...prevState,
        customTemp: {
          ...prevState.customTemp,
          ...prevState.customTemp.enable,
          enable: false,
        },
      }));
    }
    let payload = {
      name: this.state.customTemp.name,
      shouldPause: undefined,
      enable: shouldPause,
      schedules: this.state.customTemp.customSchedules,
    };
    this.props.onChangeFreezeDevice(
      'put',
      this.props.originalDevice.mac,
      'custom',
      payload,
      this.props.selectedEquipment
    );
  }

  modalCancelHandlerForADIDIssuesForm = () => {
    this.setState({ showADIDIssuesForm: false });
  };

  successErrorResetHandlerForADIDIssueForm = () => {
    this.props.onResetAdidIssueErrorSuccess();
  };

  showADIDIssuesForm = () => {
    this.setState({
      showADIDIssuesForm: true,
    });
  };

  closeModalforADIDIssuesForm = () => {
    this.setState({ showADIDIssuesForm: false });
  };

  getSpeedBoostCheck = () => {
   

    let featureFlags = sessionStorage.getItem('featureFlags');
    if (
      featureFlags.includes('speedBoost') &&
      this.props.speedBoostDevices &&
      this.props.speedBoostDevices.eligible
    ) {
      this.props.getSpeedBoostCheckDevices();
      // setTimeout(() => {
        if(this.props.speedBoostDevices && this.props.speedBoostDevices.eligible){
          const boostedDevices =
          this.props.speedBoostDevices &&
            Object.keys(this.props.speedBoostDevices).length
            ? this.props.speedBoostDevices.devices
            : [];
         const findBoostData = boostedDevices.filter(ele => { 
          const macFilter = this.props.originalDevice.mac.replaceAll(':', '');
          return ele.clientMac === macFilter;
        }); 
        const boostStatus = findBoostData ? findBoostData[0]?.boostStatus : 'Disconnected';
          // console.log('speedBoostDevice ::::', this.props.speedBoostDevices);
          this.setState({
            boostFailureReason: 'N/A',
            speedBoostCheckStatus: boostStatus ? boostStatus : 'N/A'
          });
        }
      // }, 1000)
    } else{
       const boostDevice = this.props.originalDevice.boost;
      const boostFailureReason = this.props.originalDevice.boostFailureReason;
      // console.log("bbbbbb",boostFailureReason)

      this.setState({
        boostFailureReason: boostFailureReason,
        boostDevice: boostDevice,
        speedBoostCheckStatus: boostDevice ? boostDevice : 'N/A',
        speedBoostCheckLoading: false,
      });
    }
  };
  checkScheduleConflict(scheduleInfo) {
    //  console.log('Custom temp :::', scheduleInfo);
    const templateCopy = Object.assign({}, scheduleInfo);

    if (templateCopy.customSchedules && templateCopy.customSchedules.length) {
      //  console.log('templateCopy :::', templateCopy);
      const schedule = Object.assign({}, templateCopy.customSchedules);
      const now = new Date();
      const timezone = this.props.realSettings.timezone;
      const tzString = now.toLocaleString('en-US', { timeZone: timezone });
      const day = new Date(tzString).getDay() === 0 ? 7 : new Date(tzString).getDay(); // Considering sunday as 7
      // console.log('schedule :::', schedule[0]);
      // console.log('day :::', day);

      if (schedule[0].daysOfWeek.includes(day) || (schedule[1] && !schedule[0].daysOfWeek.includes(day))) {
        const time = new Date(tzString).getHours() + ':' + new Date(tzString).getMinutes();
        //  console.log('difference ----',  schedule[0].startTime,  new Date(tzString).getTime());
        // console.log('time :::', time);
        let currentTime = time.split(':')

        let currentHour = parseInt(currentTime[0]);
        let currentMinute = currentTime[1];

        const scheduleTime = schedule[0].startTime.split(':')
        let scheduleHour = parseInt(scheduleTime[0]) === 0 ? 24 : parseInt(scheduleTime[0]);
        let scheduleMinute = scheduleTime[1];

        // console.log('Time :::',currentHour,' -- ', scheduleHour, 'Minutes :::', currentMinute, '----', scheduleMinute);
        if (currentHour == scheduleHour) {
          if (schedule[0] && schedule[0].endTime !== '' && schedule[0].endTime !== null) {
            const scheduleEndTime = schedule[0].endTime.split(':');
            const scheduleEndMinute = parseInt(scheduleEndTime[1]);
            if (currentMinute > scheduleEndMinute) {
              return false;
            }
          } else {
            if (schedule[1].daysOfWeek.includes(day)) {
              const scheduleEndTime = schedule[1].endTime.split(':');
              const scheduleEndHour = parseInt(scheduleEndTime[0]);
              const scheduleEndMinute = parseInt(scheduleEndTime[1]);
              if (currentHour > scheduleEndHour || (currentHour == scheduleEndHour && currentMinute > scheduleEndMinute)) {
                return false;
              }
            }
          }

          return true;
        } else {
          if (scheduleHour > currentHour) {
            if (scheduleHour - currentHour > 1) {
              if (scheduleHour == 24) {
                const scheduleEndTime = schedule[0].endTime.split(':')
                const scheduleEndHour = parseInt(scheduleEndTime[0]);
                // let scheduleEndMinute = scheduleEndTime[1];
                // console.log('scheduleEndHour :::', scheduleEndHour);
                if (scheduleEndHour > currentHour) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }

            } else if (scheduleHour - currentHour == 1) {
              let device = this.props.originalDevice;
              // console.log('device info :::', device)
              if (device.steering && device.steering.forced && device.steering.forced.expiresAt) {
                const remainingSterringTime = device.steering && device.steering.forced && device.steering.forced.expiresAt;
                const steeringExpiresHour = new Date(remainingSterringTime.toLocaleString('en-US', { timeZone: timezone })).getHours(); // Time at the End of steering (in seconds)
                const steeringExpiresMinute = new Date(remainingSterringTime.toLocaleString('en-US', { timeZone: timezone })).getMinutes(); // Time at the End of steering (in seconds)
                //   console.log('steeringExpiresHour :::', steeringExpiresHour, 'scheduleHour ::', scheduleHour);
                //  console.log('steeringExpiresMinute :::', steeringExpiresMinute, 'scheduleMinute :', scheduleMinute);
                if (scheduleHour > steeringExpiresHour || (scheduleHour === steeringExpiresHour && scheduleMinute > steeringExpiresMinute)) {
                  return false;
                } else {

                  return true;
                }
              } else {
                if (scheduleMinute < currentMinute) {
                  return true;
                } else {
                  return false;
                }

              }
            }
          } else if (currentHour > scheduleHour) {
            if (currentHour - scheduleHour > 1) {
              const scheduleEndTime = schedule[0].endTime.split(':')
              const scheduleEndHour = parseInt(scheduleEndTime[0]);
              // let scheduleEndMinute = scheduleEndTime[1];
              // console.log('scheduleEndHour :::', scheduleEndHour);
              if (scheduleEndHour > currentHour) {
                return true;
              } else {
                return false;
              }
              //   return false;
            } else if (currentHour - scheduleHour == 1) {
              let device = this.props.originalDevice;
              if (device.steering && device.steering.forced && device.steering.forced.expiresAt) {
                const remainingSterringTime = device.steering && device.steering.forced && device.steering.forced.expiresAt;
                const steeringExpiresHour = new Date(remainingSterringTime.toLocaleString('en-US', { timeZone: timezone })).getHours(); // Time at the End of steering (in seconds)
                const steeringExpiresMinute = new Date(remainingSterringTime.toLocaleString('en-US', { timeZone: timezone })).getMinutes(); // Time at the End of steering (in seconds)
                //   console.log('steeringExpiresHour :::', steeringExpiresHour, 'scheduleHour ::', scheduleHour);
                //  console.log('steeringExpiresMinute :::', steeringExpiresMinute, 'scheduleMinute :', scheduleMinute);
                if (scheduleHour > steeringExpiresHour || (scheduleHour === steeringExpiresHour && scheduleMinute > steeringExpiresMinute)) {
                  return false;
                } else {

                  return true;
                }
              }
            } else {
              return true;
            }
          }
        }
      }
    }

  }
  checkForLiveSchedule = (scheduleInfo) => {
    const schedule = Object.assign({}, scheduleInfo);
    const now = new Date();
    const timezone = this.props.realSettings.timezone;
    const tzString = now.toLocaleString('en-US', { timeZone: timezone });
    const time = new Date(tzString).getHours() + ':' + new Date(tzString).getMinutes();
    let currentTime = time.split(':')
    let currentHour = parseInt(currentTime[0]);

    const scheduleTime = schedule[0].startTime.split(':')
    let scheduleStartHour = parseInt(scheduleTime[0]) === 0 ? 24 : parseInt(scheduleTime[0]);
    // console.log('Checking for live schedule :::', currentHour, scheduleStartHour);
    if (scheduleStartHour - currentHour == 1 || scheduleStartHour == currentHour) {
      return true;
    }
  }

  handleDeviceSteering = (scheduleDetails = '', calledFrom = '', devicePause = false) => {
    // Checking any device with freqBand 2.4G
    let scheduleConflict = false;
    let scheduleInfo = scheduleDetails; // scheduleDetails is the new schedule object passed from GroupPauseScheduleForm.js

    // Checking group Pause
    if (devicePause) {
      scheduleConflict = true;
    } else if (this.props.originalDevice && this.props.originalDevice.freeze
      && this.props.originalDevice.freeze.suspended && this.props.originalDevice.freeze.suspended.enable) {
      this.setState({
        steeringDevices: true
      });
      return true;
    } else {
      if (scheduleInfo && scheduleInfo.enable) {
        //  console.log('scheduleInfo :::', scheduleInfo);

        scheduleConflict = this.checkScheduleConflict(scheduleInfo);
        //  console.log('originalDevice ::::',this.props.originalDevice);
        if (scheduleConflict) {
          devicePause = this.props.originalDevice?.freeze?.frozen ?? false;
          if (!devicePause && scheduleInfo && scheduleInfo.enable) {
            devicePause = true;
          }
        }
        //  console.log('devicePause ::', devicePause, scheduleInfo, 'scheduleConflict ::', scheduleConflict);
        if (!devicePause && scheduleInfo && scheduleInfo.enable && scheduleConflict) {
          scheduleConflict = this.checkForLiveSchedule(scheduleInfo.customSchedules);
        }
      }
    }
    //  console.log("SmartSteerrrrr::::", this.props.originalDevice.steering, !!Object.keys(this.props.originalDevice.steering).length)
    const isDeviceSteering = this.props.originalDevice.steering ? !!Object.keys(this.props.originalDevice.steering).length : false;
    //  console.log('scheduleConflict ::', scheduleConflict, isDeviceSteering, calledFrom);
    // if ((scheduleConflict && isDeviceSteering) || (scheduleConflict && calledFrom === 'addSteering')) {
    //   this.setState({
    //     steeringDevices: true
    //   });
    //   return true;
    // }
    // return false;
  }

  // closeScheduleSteeringMessageModal() {
  //   this.setState({
  //     steeringDevices: false
  //   })
  // }
  getMaxWifiSpeed() {
    let maxWiFiSpeed = 'N/A';
    if (
      parseInt(this.props.originalDevice.advancedDevice.qoe.phyMode, 10) <= 4 &&
      parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 1
    ) {
      if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
        maxWiFiSpeed = '54Mbps';
      } else if (
        this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
      ) {
        maxWiFiSpeed = '150Mbps';
      } else if (
        this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
      ) {
        maxWiFiSpeed = 'N/A';
      } else if (
        this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
      ) {
        maxWiFiSpeed = 'N/A';
      }
    } else if (
      parseInt(this.props.originalDevice.advancedDevice.qoe.phyMode, 10) >= 7 &&
      parseInt(this.props.originalDevice.advancedDevice.qoe.phyMode, 10) <= 14
    ) {
      if (parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 1) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '72Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '150Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 2
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '144Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '300Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 3
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '217Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '450Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 4
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '289Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '600Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = 'N/A';
        }
      }
    } else if (
      parseInt(this.props.originalDevice.advancedDevice.qoe.phyMode, 10) >= 15 &&
      parseInt(this.props.originalDevice.advancedDevice.qoe.phyMode, 10) <= 21
    ) {
      if (parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 1) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '87Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '200Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '433Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '867Mbps';
        } else {
          maxWiFiSpeed = 'N/A';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 2
      ) {

        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '173Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '400Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '867Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '1733Mbps';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 3
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '289Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '600Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '1300Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '2340Mbps';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 4
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '347Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '800Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '1733Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '3467Mbps';
        }
      }
    } else if (
      parseInt(this.props.originalDevice.advancedDevice.qoe.phyMode, 10) >= 22 &&
      parseInt(this.props.originalDevice.advancedDevice.qoe.phyMode, 10) <= 32
    ) {
      if (parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 1) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '143Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '287Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '601Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '1201Mbps';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 2
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '287Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '574Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '1201Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '2402Mbps';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 3
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '430Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '860Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '1802Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '3603Mbps';
        }
      } else if (
        parseInt(this.props.originalDevice.advancedDevice.qoe.nss, 10) === 4
      ) {
        if (this.props.originalDevice.advancedDevice.qoe.chWidth === '20 MHz') {
          maxWiFiSpeed = '574Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '40 MHz'
        ) {
          maxWiFiSpeed = '1147Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '80 MHz'
        ) {
          maxWiFiSpeed = '2402Mbps';
        } else if (
          this.props.originalDevice.advancedDevice.qoe.chWidth === '160 MHz'
        ) {
          maxWiFiSpeed = '4804Mbps';
        }
      }
    }
    return maxWiFiSpeed;
  }


  render() {
    let featureFlags = sessionStorage.getItem('featureFlags');
    const isDeviceSteering = this.props.originalDevice.steering ? !!Object.keys(this.props.originalDevice.steering).length : false;
    const isPhoneOrTabletAdvancedDeviceId = ['Phone', 'Tablet','Default'].includes(this.props.advancedDeviceIdsType);
    // console.log(this.props.advancedDeviceIdsType, "this.props.advancedDeviceIdsType")
    const isDeviceSteeringWith5GOr6G = this.props.originalDevice.freqBand && isPhoneOrTabletAdvancedDeviceId
      && ((this.props.originalDevice.freqBand.includes('5G') || this.props.originalDevice.freqBand.includes('5g'))
        || (this.props.originalDevice.freqBand.includes('6G') || this.props.originalDevice.freqBand.includes('6g')));
    const isTwoFourDeviceSteering = this.props.originalDevice.freqBand && isPhoneOrTabletAdvancedDeviceId &&
      (this.props.originalDevice.freqBand.includes('2.4g') || this.props.originalDevice.freqBand.includes('2.4G'));
    const isTwoFourForcedSteering = isDeviceSteering && isTwoFourDeviceSteering &&
      (this.props.originalDevice.steering.forced.freqBand.includes('2.4g') || this.props.originalDevice.steering.forced.freqBand.includes('2.4G'));
    let speedBoostCheck = <div />;
    if (
      (featureFlags &&
        featureFlags.includes('speedBoost')) &&
      (this.props.speedBoostDevices &&
        'eligible' in this.props.speedBoostDevices === false) &&
      !this.props.speedBoostDevicesLoading
    ) {

      speedBoostCheck = (
        <div className={classes.speedBoostCheck}>
          <div className={classes.flexContainerRunCheck}>
            <h3>Speed Boost Check</h3>
            {/* <button
              className={classes.speedRunCheckBtn}
              onClick={this.getSpeedBoostCheck}
            >
              Run Check
            </button> */}
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaExclamationCircle
              color={'red'}
              fontSize={'30px'}
              style={{ marginRight: '10px' }}
            />
            <p style={{ display: 'flex', flexDirection: 'column' }}>
              <span>Speed Boost eligibility cannot be determined at this moment</span>
            </p>
          </div>
        </div>
      );
    }
    if (featureFlags &&
      featureFlags.includes('speedBoost')) {
      if (

        this.props.speedBoostDevices &&
        this.props.speedBoostDevices.eligible &&
        !this.props.speedBoostDevicesLoading
      ) {
        // console.log("SpeedBost", this.state.boostFailureReason, this.state.speedBoostCheckStatus )
        const disableRunCheck = ['congestion'].indexOf(this.state.boostFailureReason) !==
          -1 || (['CAPABLE', 'BOOSTED'].indexOf(this.state.speedBoostCheckStatus) !==
            -1 && (['congestion'].indexOf(this.state.boostFailureReason) ===
              -1)) || (['', 'CAPABLE', 'BOOSTED'].indexOf(
                this.state.speedBoostCheckStatus
              ) === -1 && (['congestion'].indexOf(this.state.boostFailureReason) ===
                -1)) ? true : false;

              const speedBoostStatus =  () => {
                if(['congestion'].indexOf(this.state.boostFailureReason) !== -1){ 
                  return (
                    <p style={{ display: 'flex', alignItems: 'center' }}>
                      <FaExclamationCircle
                        color={'red'}
                        fontSize={'30px'}
                        style={{ marginRight: '10px' }}
                      />
                      Speed Boost has failed due to network congestion.
                    </p>
                  )
                } else if(['CAPABLE', 'BOOSTED'].indexOf(this.state.speedBoostCheckStatus) !== -1 && 
                 (['congestion'].indexOf(this.state.boostFailureReason) === -1)){
                  return (
                    <p style={{ display: 'flex', alignItems: 'center' }}>
                      <FaCheckCircle
                        color={'green'}
                        fontSize={'30px'}
                        style={{ marginRight: '10px' }}
                      />
                      Great News! Speed boost is available for this device.
                    </p>
                  )
                } else if (['', 'CAPABLE', 'BOOSTED'].indexOf(this.state.speedBoostCheckStatus) === -1 &&
                 (['congestion'].indexOf(this.state.boostFailureReason) === -1)){
                  return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <FaExclamationCircle
                        color={'red'}
                        fontSize={'30px'}
                        style={{ marginRight: '10px' }}
                      />
                      <p style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>Sorry! Speed boost is not available for this Device</span>
                        <b>Further Discussion is Needed with Account Holder</b>
                      </p>
                    </div>
                  )
                }
              }
               
        speedBoostCheck = (
          <div className={classes.speedBoostCheck}>
            <div className={classes.flexContainerRunCheck}>
              <h3>Speed Boost Check</h3>
              <button
                className={classes.speedRunCheckBtn}
                onClick={this.getSpeedBoostCheck}
                disabled={disableRunCheck}
              >
                Run Check
              </button>
            </div>
           {speedBoostStatus()}
          </div>
        );
      } else if (

        this.props.speedBoostDevicesLoading
      ) {
        speedBoostCheck = (
          <div className={classes.speedBoostCheck}>
            <div className={classes.flexContainerRunCheck}>
              <h3>Speed Boost Check</h3>
              <button
                className={classes.speedRunCheckBtn}
                onClick={this.getSpeedBoostCheck}
              >
                Run Check
              </button>
            </div>

            <div style={{ padding: '20px', textAlign: 'center' }}>
              <div>
                <FaSpinner
                  fontSize={'25px'}
                  style={{ color: '#0073d1', marginRight: '5px' }}
                  className={[
                    classes.fa,
                    classes.facircleonotch,
                    classes.faspin,
                    classes.fa3x,
                    classes.fafw,
                  ].join(' ')}
                />
              </div>
              Please wait for Speed Boost Check.
            </div>
          </div>
        );
      }
    }


    let advancedDevice, freq;
    let { showEditDevName } = this.state;
    if (this.props.originalDevice.connectionState === 'disconnected') {
      freq = 'N/A';
    } else if (
      this.props.originalDevice.medium &&
      this.props.originalDevice.medium === 'wifi'
    ) {
      if (
        this.props.originalDevice.freqBand &&
        (this.props.originalDevice.freqBand.includes('6G') ||
          this.props.originalDevice.freqBand.includes('6g'))
      ) {
        freq = '6GHz';
      }
      else if (
        this.props.originalDevice.freqBand &&
        (this.props.originalDevice.freqBand.includes('5G') ||
          this.props.originalDevice.freqBand.includes('5g'))
      ) {
        freq = '5GHz';
      } else if (
        this.props.originalDevice.freqBand &&
        (this.props.originalDevice.freqBand.includes('2.4G') ||
          this.props.originalDevice.freqBand.includes('2.4g'))
      ) {
        freq = '2.4GHz';
      } else {
        freq = 'N/A';
      }
    } else if (
      this.props.originalDevice.medium &&
      this.props.originalDevice.medium === 'ethernet'
    ) {
      freq = 'Ethernet';
    } else {
      freq = 'N/A';
    }
    let statsDateRange =
      this.props.originalDevice.advancedDevice &&
        this.props.originalDevice.advancedDevice.rssi
        ? this.props.originalDevice.advancedDevice.rssi.statsDateRange
        : null;
    let rssiAlarmHistoryComp = this.state.rssiAvailable ? (
      <RSSIAlarmHistory
        days={this.state.days}
        title="RSSI Alarm History"
        mappedRssi={
          this.state.days === '1'
            ? this.state.mappedRssi.slice(0, 97)
            : this.state.mappedRssi
        }
      />
    ) : (
      <div style={{ margin: '25px 25px 25px 10px', color: 'gray' }}>
        Alarms History Data Not Available
      </div>
    );
    let deviceBusynessComp = this.state.transmittedAvailable ? (
      <DeviceBusyness
        days={this.state.days}
        title="Device Busyness"
        mappedTransmitted={
          this.state.days === '1'
            ? this.state.mappedTransmitted.slice(0, 97)
            : this.state.mappedTransmitted
        }
      />
    ) : (
      <div style={{ margin: '25px 25px 25px 10px', color: 'gray' }}>
        Device Busyness Data Not Available
      </div>
    );
    let deviceOnlinStatusComp = this.state.rssiAvailable ? (
      <DeviceOnlineStatus
        days={this.state.days}
        title="Device Online Status"
        mappedRssi={
          this.state.days === '1'
            ? this.state.mappedRssi.slice(0, 97)
            : this.state.mappedRssi
        }
      />
    ) : (
      <div style={{ margin: '25px 25px 25px 10px', color: 'gray' }}>
        Device Online Status Data Not Available
      </div>
    );
    let rssiComp = this.state.rssiAvailable ? (
      <RSSI
        days={this.state.days}
        unit={'hour'}
        statsDateRange={statsDateRange}
        dataset={
          this.state.days === '1'
            ? this.state.rssiData1Day
            : this.state.rssiData7Day
        }
      />
    ) : (
      <div style={{ margin: '25px 25px 25px 10px', color: 'gray' }}>
        RSSI Over Time Data Not Available
      </div>
    );
    let alarmsSummaryComp = this.state.rssiAvailable ? (
      <AlarmsSummary
        name="Alarms Summary"
        columns={['Time', 'Warnings', 'Alarms']}
        rows={[
          ['Last 15 Min', this.state.warnings15, this.state.alarms15],
          ['Last 24 Hours', this.state.warnings24, this.state.alarms24],
          ['Last 7 Days', this.state.warnings7, this.state.alarms7],
          ['Last 30 Days', this.state.warnings30, this.state.alarms30],
        ]}
      />
    ) : (
      <div style={{ margin: '25px 25px 25px 10px', color: 'gray' }}>
        Alarms Summary Data Not Available
      </div>
    );
    let steeringEventsComp;
    if (
      this.state.days === '1' &&
      this.state.bandSteering1Day &&
      this.state.bandSteering1Day.length
    ) {
      steeringEventsComp = (
        <SteeringEvents
          days={this.state.days}
          name="Band Steering Events"
          events={this.state.bandSteering1Day}
        />
      );
    } else if (
      this.state.days === '7' &&
      this.state.bandSteering7Day &&
      this.state.bandSteering7Day.length
    ) {
      steeringEventsComp = (
        <SteeringEvents
          days={this.state.days}
          name="Band Steering Events"
          events={this.state.bandSteering7Day}
        />
      );
    } else {
      steeringEventsComp = (
        <SteeringEvents noEvents={true} name="Band Steering Events" />
      );
    }
    let steeringComp =
      this.props.originalDevice.advancedDevice &&
        this.props.originalDevice.advancedDevice.bandSteeringSummary ? (
        <Steering
          name="Band Steering"
          columns={['Time', 'Attempts', 'Success', 'Failures']}
          rows={this.prepareBandSteeringSummaryTable(
            this.props.originalDevice.advancedDevice
              ? this.props.originalDevice.advancedDevice.bandSteeringSummary
              : null
          )}
        />
      ) : (
        <div style={{ margin: 25, color: 'gray' }}>
          Band Steering Data Not Available
        </div>
      );
    if (
      this.state.rssiData1Day === null &&
      this.props.originalDevice.advancedDevice &&
      this.props.originalDevice.advancedDevice.rssi
    ) {
      // console.log('OPEN HANDLER START');
      this.openHandler();
    }

    if (
      !this.props.originalDevice.medium ||
      (this.props.originalDevice.medium &&
        this.props.originalDevice.medium !== 'wifi')
    ) {
      advancedDevice = <div />;
    } else if (
      this.state.mappedTransmitted === null ||
      this.state.rssiData1Day === null
    ) {
      advancedDevice = <Spinner />;
    } else if (
      this.state.rssiData1Day !== null &&
      this.state.mappedTransmitted !== null
    ) {
      advancedDevice = (
        <div>
          <div
            className={classes.BodyRow}
            style={{ background: 'none', margin: '10px 10px 10px 14px' }}
          >
            <div className={classes.BodyTitle}>
              <b>Device History</b>
            </div>
            <div className={classes.DeviceDetailSelect}>
              {/* <select
                id='daySelection'
                style={{ cursor: 'pointer' }}
                value={this.state.days}
                onChange={this.dayHandler}
              >
                <option value="1">Last 24 Hours</option>
                <option value="7">Last 7 Days</option>
              </select> */}


              <SelectDropdown
                height={'30px'}
                width={'150px'}
                name="deviceDetails"
                defaultValue={this.state.daysOptions.filter(option => option.value == this.state.days)}
                options={this.state.daysOptions}
                isSearchable={false}
                onChange={(e) => {
                  this.dayHandler(e)}}
              />
            </div>
          </div>
          {rssiAlarmHistoryComp}
          {deviceBusynessComp}
          {deviceOnlinStatusComp}
          {alarmsSummaryComp}
          {rssiComp}
          {steeringEventsComp}
          {steeringComp}
          <div style={{ height: '60px' }}></div>
        </div>
      );
    }

    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrows) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }
    let interferenceSection;
    if (
      this.props.originalDevice.advancedDevice && this.props.originalDevice.advancedDevice.qoe &&
      this.props.originalDevice.advancedDevice.qoe.interference
    ) {
      interferenceSection = (
        <div className={classes.DoubleBodyRow} style={{ marginTop: '0px' }}>
          <div
            className={classes.Capabilities}
            style={{
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'row',
            }}
          >
            <div className={classes.BodyColumnInner} style={{ flex: 0 }}>
              <div className={classes.BodyTitle} style={{ color: '#000' }}>
                Interference{' '}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                marginRight: 10,
                flexWrap: 'nowrap',
                border: '1px solid lightgray',
                backgroundColor: 'white',
                height: 18,
                width: '30%',
                borderRadius: 9,
              }}
            >
              <div
                style={{
                  backgroundColor: '#0073d1',
                  width: this.props.originalDevice.advancedDevice.qoe.interference,
                  margin: 0,
                  borderBottomLeftRadius: 9,
                  borderTopLeftRadius: 9,
                }}
              ></div>
            </div>
            <div id="DeviceInterference">
              {this.props.originalDevice.advancedDevice.qoe.interference}
            </div>
          </div>
        </div>
      );
    } else {
      interferenceSection = <div />;
    }
    let capabilities6g, capabilities, capabilities1, freqy;

    if (
      this.props.originalDevice.freqBand &&
      this.props.originalDevice.freqBand.includes('6G')
    ) {
      freqy = '(6GHz)';
    }
    if (
      this.props.originalDevice.freqBand &&
      this.props.originalDevice.freqBand.includes('5G')
    ) {
      freqy = '(5GHz)';
    }
    if (
      this.props.originalDevice.freqBand &&
      this.props.originalDevice.freqBand.includes('2.4G')
    ) {
      freqy = '(2.4GHz)';
    }

    if (
      this.props.originalDevice.freqBand &&
      this.props.originalDevice.advancedDevice && this.props.originalDevice.advancedDevice.qoe
    ) {
      capabilities6g = (
        <div className={classes.DoubleBodyRow} style={{ marginBottom: '10px' }}>
          <div className={classes.Capabilities}>
            <div className={classes.BodyColumnInner}>
              <div
                id="capabilities"
                className={classes.BodyInfo}
                style={{ color: '#000' }}
              >
                Capabilities (6GHz)
              </div>
            </div>
            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo}>Antenna: </div>
              <div
                id="antenna"
                className={classes.BodyInfo}
                style={{ flex: '2' }}
              >
                {freqy === '(6GHz)' && this.props.originalDevice.advancedDevice.qoe.nss
                  ? this.props.originalDevice.advancedDevice.qoe.nss +
                  'X' +
                  this.props.originalDevice.advancedDevice.qoe.nss
                  : 'N/A'}
              </div>
            </div>
            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo}>WiFi Standard: </div>
              <div
                id="wifistandard"
                className={classes.BodyInfo}
                style={{ flex: '2' }}
              >
                {freqy !== '(6GHz)' ? 'N/A' :
                  this.props.originalDevice.advancedDevice.qoe.phyMode === '1'
                    ? '802.11'
                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '2'
                      ? '802.11a'
                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '3'
                        ? '802.11b'
                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '4'
                          ? '802.11g'
                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '7'
                            ? '802.11n'
                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '8'
                              ? '802.11n'
                              : this.props.originalDevice.advancedDevice.qoe.phyMode === '9'
                                ? '802.11n'
                                : this.props.originalDevice.advancedDevice.qoe.phyMode === '10'
                                  ? '802.11n'
                                  : this.props.originalDevice.advancedDevice.qoe.phyMode === '11'
                                    ? '802.11n'
                                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '12'
                                      ? '802.11n'
                                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '13'
                                        ? '802.11n'
                                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '14'
                                          ? '802.11n'
                                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '15'
                                            ? '802.11ac'
                                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '16'
                                              ? '802.11ac'
                                              : this.props.originalDevice.advancedDevice.qoe.phyMode === '17'
                                                ? '802.11ac'
                                                : this.props.originalDevice.advancedDevice.qoe.phyMode === '18'
                                                  ? '802.11ac'
                                                  : this.props.originalDevice.advancedDevice.qoe.phyMode === '19'
                                                    ? '802.11ac'
                                                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '20'
                                                      ? '802.11ac'
                                                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '21'
                                                        ? '802.11ac'
                                                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '22'
                                                          ? '802.11ax'
                                                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '23'
                                                            ? '802.11ax'
                                                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '24'
                                                              ? '802.11ax'
                                                              : this.props.originalDevice.advancedDevice.qoe.phyMode === '25'
                                                                ? '802.11ax'
                                                                : this.props.originalDevice.advancedDevice.qoe.phyMode === '26'
                                                                  ? '802.11ax'
                                                                  : this.props.originalDevice.advancedDevice.qoe.phyMode === '27'
                                                                    ? '802.11ax'
                                                                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '28'
                                                                      ? '802.11ax'
                                                                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '29'
                                                                        ? '802.11ax'
                                                                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '30'
                                                                          ? '802.11ax'
                                                                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '31'
                                                                            ? '802.11ax'
                                                                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '32'
                                                                              ? '802.11ax'
                                                                              : 'N/A'
                }
              </div>
            </div>

            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo} style={{ flex: '1' }}>
                Bandwidth:
              </div>
              <div
                id="bandwidth"
                className={classes.BodyInfo}
                style={{ flex: '3' }}
              >
                {freqy !== '(6GHz)' ? 'N/A' :
                  this.props.originalDevice.advancedDevice.qoe.chWidth === undefined
                    ? 'N/A'
                    : this.props.originalDevice.advancedDevice.qoe.chWidth
                }
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      capabilities6g = <div />;
    }

    if (
      this.props.originalDevice.freqBand &&
      this.props.originalDevice.advancedDevice && this.props.originalDevice.advancedDevice.qoe
    ) {
      capabilities = (
        <div className={classes.DoubleBodyRow} style={{ marginBottom: '10px' }}>
          <div className={classes.Capabilities}>
            <div className={classes.BodyColumnInner}>
              <div
                id="capabilities"
                className={classes.BodyInfo}
                style={{ color: '#000' }}
              >
                Capabilities {freqy !== '(6GHz)' ? freqy : '(2.4GHz)'}
              </div>
            </div>
            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo}>Antenna: </div>
              <div
                id="antenna"
                className={classes.BodyInfo}
                style={{ flex: '2' }}
              >
                {freqy !== '(6GHz)' && this.props.originalDevice.advancedDevice.qoe.nss
                  ? this.props.originalDevice.advancedDevice.qoe.nss +
                  'X' +
                  this.props.originalDevice.advancedDevice.qoe.nss
                  : 'N/A'}
              </div>
            </div>
            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo}>WiFi Standard: </div>
              <div
                id="wifistandard"
                className={classes.BodyInfo}
                style={{ flex: '2' }}
              >
                {freqy === '(6GHz)' ? 'N/A' :
                  this.props.originalDevice.advancedDevice.qoe.phyMode === '1'
                    ? '802.11'
                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '2'
                      ? '802.11a'
                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '3'
                        ? '802.11b'
                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '4'
                          ? '802.11g'
                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '7'
                            ? '802.11n'
                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '8'
                              ? '802.11n'
                              : this.props.originalDevice.advancedDevice.qoe.phyMode === '9'
                                ? '802.11n'
                                : this.props.originalDevice.advancedDevice.qoe.phyMode === '10'
                                  ? '802.11n'
                                  : this.props.originalDevice.advancedDevice.qoe.phyMode === '11'
                                    ? '802.11n'
                                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '12'
                                      ? '802.11n'
                                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '13'
                                        ? '802.11n'
                                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '14'
                                          ? '802.11n'
                                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '15'
                                            ? '802.11ac'
                                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '16'
                                              ? '802.11ac'
                                              : this.props.originalDevice.advancedDevice.qoe.phyMode === '17'
                                                ? '802.11ac'
                                                : this.props.originalDevice.advancedDevice.qoe.phyMode === '18'
                                                  ? '802.11ac'
                                                  : this.props.originalDevice.advancedDevice.qoe.phyMode === '19'
                                                    ? '802.11ac'
                                                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '20'
                                                      ? '802.11ac'
                                                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '21'
                                                        ? '802.11ac'
                                                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '22'
                                                          ? '802.11ax'
                                                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '23'
                                                            ? '802.11ax'
                                                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '24'
                                                              ? '802.11ax'
                                                              : this.props.originalDevice.advancedDevice.qoe.phyMode === '25'
                                                                ? '802.11ax'
                                                                : this.props.originalDevice.advancedDevice.qoe.phyMode === '26'
                                                                  ? '802.11ax'
                                                                  : this.props.originalDevice.advancedDevice.qoe.phyMode === '27'
                                                                    ? '802.11ax'
                                                                    : this.props.originalDevice.advancedDevice.qoe.phyMode === '28'
                                                                      ? '802.11ax'
                                                                      : this.props.originalDevice.advancedDevice.qoe.phyMode === '29'
                                                                        ? '802.11ax'
                                                                        : this.props.originalDevice.advancedDevice.qoe.phyMode === '30'
                                                                          ? '802.11ax'
                                                                          : this.props.originalDevice.advancedDevice.qoe.phyMode === '31'
                                                                            ? '802.11ax'
                                                                            : this.props.originalDevice.advancedDevice.qoe.phyMode === '32'
                                                                              ? '802.11ax'
                                                                              : 'N/A'
                }
              </div>
            </div>

            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo} style={{ flex: '1' }}>
                Bandwidth:
              </div>
              <div
                id="bandwidth"
                className={classes.BodyInfo}
                style={{ flex: '3' }}
              >
                {
                  freqy === '(6GHz)' ? 'N/A' :
                    this.props.originalDevice.advancedDevice.qoe.chWidth === undefined
                      ? 'N/A'
                      : this.props.originalDevice.advancedDevice.qoe.chWidth
                }
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      capabilities = <div />;
    }

    if (
      this.props.originalDevice.freqBand &&
      this.props.originalDevice.advancedDevice && this.props.originalDevice.advancedDevice.qoe
    ) {
      capabilities1 = (
        <div
          className={classes.DoubleBodyRow}
          style={{ marginTop: '0px', marginBottom: '10px' }}
        >
          <div className={classes.Capabilities}>
            <div className={classes.BodyColumnInner}>
              <div
                id="capabilities"
                className={classes.BodyInfo}
                style={{ color: '#000' }}
              >
                Capabilities {freqy === '(5GHz)' ? '(2.4GHz)' : '(5GHz)'}
              </div>
            </div>
            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo}>Antenna: </div>
              <div
                id="antenna"
                className={classes.BodyInfo}
                style={{ flex: '2' }}
              >
                N/A
              </div>
            </div>
            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo}>WiFi Standard: </div>
              <div
                id="wifistandard"
                className={classes.BodyInfo}
                style={{ flex: '2' }}
              >
                {'N/A'}
              </div>
            </div>

            <div className={classes.BodyColumnInner}>
              <div className={classes.BodyInfo} style={{ flex: '1' }}>
                Bandwidth:
              </div>
              <div
                id="bandwidth"
                className={classes.BodyInfo}
                style={{ flex: '3' }}
              >
                {'N/A'}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      capabilities1 = <div />;
    }
    let temp = capabilities;
    let temp1 = capabilities1;
    if (freqy === '(2.4GHz)') {
      capabilities1 = temp;
      capabilities = temp1;
    } else if (freqy === '(6GHz)') {
      capabilities1 = temp;
      capabilities = temp1;
    }

    let outOfHome = <div />;

    if (
      this.props.originalDevice.outOfHome &&
      this.props.originalDevice.outOfHome === true
    ) {
      outOfHome = (
        <span id="outOfHome" style={{ paddingLeft: 5 }}>
          ( Out of Home )
        </span>
      );
    }

    let trash;
    if (
      this.props.originalDevice.connectionState &&
      this.props.originalDevice.connectionState === 'connected'
    ) {
      trash = <div style={{ display: 'none' }} />;
    } else {
      trash = (
        <button
          id="TrashButton"
          onClick={this.submitDeleteDeviceHandler}
          className={classes.TrashButton}
        >
          <FaTrash color={'gray'} />
        </button>
      );
    }
    const handleTimeEnd = () => {
      this.props.stopSteering({ routerMac: this.props.routerMac, deviceMac: this.props.originalDevice.mac })
    }

    let leftOutTime = '60';
    if (this.props.originalDevice && this.props.originalDevice.steering && this.props.originalDevice.steering.forced && this.props.originalDevice.steering.forced.expiresAt) {
      // console.log('coming into it');
      leftOutTime = (
        <DeviceSterringCountDownTimer
          className={classes.Timer}
          handleTimeEnd={handleTimeEnd}
          expiresAt={this.props.originalDevice.steering.forced.expiresAt}
        />
      );
    }

    let pauseScheduleLink;
    if (this.state.customTemp !== null) {
      pauseScheduleLink = (
        <PauseScheduleLink
          routerMac={this.props.realSettings && this.props.realSettings.mac}
          devMac={this.props.originalDevice && this.props.originalDevice.mac}
          freeze={
            this.props.originalDevice.freeze
              ? this.props.originalDevice.freeze
              : undefined
          }
          customTemp={this.state.customTemp}
          modalCancel={this.confirmModalCancelHandler}
          updateScheduleDetails={this.props.updateScheduleDetails}
          deviceGroupName={this.props.deviceGroupName}
          setEquipmentSelection={this.setEquipmentSelection}
          isDeviceSteering={isDeviceSteering}
          handleDeviceSteering={this.handleDeviceSteering}
          leftOutTime={leftOutTime}
          isDeviceSuspend={this.props.originalDevice.freeze.suspended.enable}
          selectedEquipment={this.props.selectedEquipment}

        />
      );
    } else {
      pauseScheduleLink = <div />;
    }
    let showDeviceEditModal;
    let deviceIconUrl = this.props.deviceIconUrl;
    if (this.state.showEditDevName) {
      showDeviceEditModal = (
        <div>
          <div className={classes.deviceDiv}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginRight: '20px',
              }}
            >
              <DeviceIcon iconUrl={deviceIconUrl} size={50} />
            </div>
            <div className={classes.deviceOverView}>
              <div
                className={[
                  showEditDevName ? '' : classes.HideEditDevName,
                ].join('')}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="text"
                    style={{ width: '155px' }}
                    name="deviceName"
                    minLength=""
                    maxLength="30"
                    required
                    value={this.state.controls.deviceName.value}
                    onChange={this.handleDeviceNameChange}
                  />

                  <button
                    id="saveDeviceName"
                    style={{
                      background: 'none',
                      border: 'none',
                      marginLeft: '10px',
                    }}
                    title="Change Device Name"
                    onClick={this.submitDeviceNameHandler}
                    disabled={!this.state.saveDeviceBtn}
                  >
                    <FaCheck color={!this.state.saveDeviceBtn ? 'gray' : 'green'} />
                  </button>

                  <button
                    style={{ background: 'none', border: 'none' }}
                    onClick={this.cancelDevName}
                    id="cancelDeviceName"
                    title="Cancel Device Name"
                  >
                    <FaTimes color={'red'} />
                  </button>
                </div>
                <div className={classes.Helper}>4-30 characters</div>
                <div id='deviceErrorMsg' className={classes.InvalidNicknameWarning}>{this.state.deviceNicknameWarning}</div>
                <div
                  style={{
                    color:
                      this.props.signalStatus === 'Excellent' ||
                        this.props.signalStatus === 'Good'
                        ? 'green'
                        : this.props.signalStatus === 'Calculating'
                          ? 'orange'
                          : this.props.signalStatus === 'Poor' ||
                            this.props.signalStatus === 'Fair' ||
                            this.props.signalStatus === 'Disconnected'
                            ? 'red'
                            : 'none',
                  }}
                >
                  <div
                    className={classes.connColor}
                    style={{
                      background:
                        this.props.signalStatus === 'Excellent' ||
                          this.props.signalStatus === 'Good'
                          ? 'green'
                          : this.props.signalStatus === 'Calculating'
                            ? 'orange'
                            : this.props.signalStatus === 'Poor' ||
                              this.props.signalStatus === 'Fair' ||
                              this.props.signalStatus === 'Disconnected'
                              ? 'red'
                              : this.props.signalStatus === 'Paused'
                                ? 'grey'
                                : 'none',
                    }}
                  ></div>
                  {this.props.signalStatus !== 'Disconnected'
                    ? this.props.signalStatus + 'Connection'
                    : this.props.signalStatus}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    let bodyAreaClassName = classes.BodyArea;
    if (this.state.confirmModal) {
      bodyAreaClassName += ' ' + classes.bodyAreaConfirmModal;
    }

    let deviceModel;
    let advancedDeviceId = this.props.originalDevice.advancedDevice
      ? this.props.originalDevice.advancedDevice.advancedDeviceId
      : 'undefined';
    if (advancedDeviceId && advancedDeviceId.model) {
      deviceModel = advancedDeviceId.model;
    } else {
      deviceModel = 'N/A';
    }

    let changeGroupObject = {
      deviceMac: this.props.originalDevice.mac,
      showMoveDeviceModal: true,
      groupName: this.props.deviceGroupName,
    };
    let groupInfoHtml;
    if (
      this.props.deviceGroupName === 'Ungrouped' ||
      this.props.deviceGroupName === 'UnGrouped'
    ) {
      groupInfoHtml = (
        <div
          id="groupName"
          style={{ marginBottom: '0px', flex: '1', cursor: 'pointer' }}
        >
          <span style={{ wordBreak: 'break-all', whiteSpace: 'initial' }}>{this.props.deviceGroupName}</span>
        </div>
      );
    } else {
      groupInfoHtml = (
        <div
          id="groupName"
          style={{
            whiteSpace: 'initial',
            marginBottom: '0px',
            wordBreak: 'break-word',
            flex: '1',
            color: '#0073d1',
            cursor: 'pointer',
          }}
        >
          <span ref={this.dropDownRef}>
            {' '}
            <span style={{ wordBreak: 'break-all', whiteSpace: 'initial' }}>{this.props.deviceGroupName}</span>
            <FaSortDown id="groupDropdown" color={'#0073d1'} />
          </span>
          <div className={classes.Dropdown}>
            <div
              id="myDropdown"
              className={classes.DropdownContent}
              style={{
                display: this.state.showDropDownList ? 'block' : 'none',
              }}
            >
              <Link
                to={{
                  pathname: '/advancedconfigurations',
                  query: changeGroupObject,
                }}
                onClick={this.setEquipmentSelection}
              >
                Change Group
              </Link>
            </div>
          </div>
        </div>
      );
    }
    let desktopSchedulePauseHtml, schedulePauseButtonHtml;
    if (this.state.customTemp) {
      desktopSchedulePauseHtml = (
        <Box>
          <div
            className={classes.ScheduleEnableButton}
            style={
              this.props.deviceGroupName === 'Ungrouped' ||
                this.props.deviceGroupName === 'UnGrouped'
                ? {}
                : {
                  background: 'none',
                  pointerEvents: 'none',
                  opacity: '0.5',
                  color: 'dimgrey',
                }
            }
          >
            <Switch
              aria-checked={
                this.state.customTemp && this.state.customTemp.enable
                  ? this.state.customTemp.enable
                  : false
              }
              aria-label="enable schedule"
              onText="ENABLED"
              offText="DISABLED"
              onChange={this.handleDeviceScheduleEnableDisable}
              checked={
                this.state.customTemp && this.state.customTemp.enable
                  ? this.state.customTemp.enable
                  : false
              }
            />
          </div>
        </Box>
      );
    } else {
      desktopSchedulePauseHtml = <div> </div>;
    }
    if (
      this.state.customTemp &&
      this.state.customTemp.customSchedules &&
      this.state.customTemp.customSchedules.length
    ) {
      schedulePauseButtonHtml = (
        <div className={classes.EditBodyRowPause}>
          <div id="scheduleName" className={classes.BodyTitle}>
            {this.state.customTemp && this.state.customTemp.name
              ? this.state.customTemp.name
              : ''}
          </div>
          <div className={classes.BodyInfo}>{desktopSchedulePauseHtml}</div>

          <div id="DeviceSchedulePause" className={classes.showDesktop}>
            {pauseScheduleLink}
          </div>
        </div>
      );
    } else if ((this.state.customTemp && this.state.customTemp.name) || this.state.customTemp === undefined) {
      schedulePauseButtonHtml = (
        <div className={classes.CreateBodyRowPause}>
          <div className={classes.BodyTitle}>
            {this.state.customTemp && this.state.customTemp.name
              ? this.state.customTemp.name
              : ''}
          </div>
          <div className={classes.BodyInfo}>{desktopSchedulePauseHtml}</div>

          <div className={classes.showDesktop}>{pauseScheduleLink}</div>
        </div>
      );
    } else {
      schedulePauseButtonHtml = '';

    }
    let confirmAction, confirmMsgStyling;
    if (this.state.action === 'scheduled pause status') {
      confirmAction = (
        <div
          style={{
            paddingBottom: '10px',
            fontSize: '1.0rem',
            fontWeight: 'normal ',
            fontFamily: 'Open Sans,serif',
            color: '#4e4545',
            textAlign: 'center',
          }}
        >
          Are you sure you want to proceed ?
        </div>
      );
      confirmMsgStyling = true;
    } else {
      confirmMsgStyling = false;
      confirmAction = this.state.action.includes('schedule')
        ? this.state.checked
          ? 'unpause this device'
          : 'pause this device'
        : this.state.action;
    }

    let mobileSchedulePauseButtonHtml;

    if (
      this.state.customTemp &&
      this.state.customTemp.customSchedules &&
      this.state.customTemp.customSchedules.length
    ) {
      mobileSchedulePauseButtonHtml = (
        <div className={classes.flexContainer}>
          <div
            className={classes.flexContainer}
            style={{ flex: '1 1', flexDirection: 'column' }}
          >
            <div
              className={classes.flexContainer}
              style={{
                flex: '1 1',
                margin: '0px',
                paddingBottom: '0px',
                paddingTop: '0px',
              }}
            >
              <div className={classes.BodyTitle}>
                <span
                  style={{
                    overflowWrap: 'break-word',
                    width: '160px',
                    whiteSpace: 'normal',
                  }}
                >
                  {this.state.customTemp && this.state.customTemp.name
                    ? this.state.customTemp.name
                    : ''}
                </span>
              </div>
              <div className={classes.BodyInfo}>{desktopSchedulePauseHtml}</div>
            </div>
            <div
              className={classes.flexContainer}
              style={{
                flex: '1 1',
                margin: '0px',
                paddingBottom: '0px',
                paddingTop: '0px',
              }}
            >
              <div className={classes.showMobile}>{pauseScheduleLink}</div>
            </div>
          </div>
        </div>
      );
    } else if ((this.state.customTemp && this.state.customTemp.name) || this.state.customTemp === undefined) {
      mobileSchedulePauseButtonHtml = (
        <div className={classes.flexContainer}>
          <div
            className={classes.flexContainer}
            style={{ flex: '1 1', flexDirection: 'column' }}
          >
            <div className={classes.showMobile}>{pauseScheduleLink}</div>
          </div>
        </div>
      );
    } else {
      mobileSchedulePauseButtonHtml = '';
    }
    let wifiMaxSpeed = 'N/A';
    if (this.props.originalDevice?.advancedDevice?.qoe) {
      wifiMaxSpeed = this.getMaxWifiSpeed();
    }

    return (
      <Box>
        <div className={bodyAreaClassName}>
          <div className={classes.Separator}></div>
          <div>
            <div className={classes.flexContainer}>
              {trash}
              <div
                className={classes.deviceDiv}
                style={{ flex: '1 1', background: 'none' }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginRight: '20px',
                  }}
                >
                  <DeviceIcon iconUrl={deviceIconUrl} size={50} />
                </div>
                <div style={{ width: '100%' }}>
                  <b
                    id="DeviceName"
                    className={
                      !showEditDevName
                        ? classes.displayDeviceName
                        : classes.HideEditDevName
                    }
                  >
                    {this.props.isLoading ? '' : this.props.devName}
                  </b>
                  <button
                    id="EditDeviceName"
                    aria-label="Edit Device Name"
                    className={!showEditDevName ? '' : classes.HideEditDevName}
                    style={{ background: 'none', border: 'none' }}
                    onClick={this.toggleEditDevName}
                  >
                    <FaPencilAlt color={'gray'} />
                  </button>
                  <div
                    id="DeviceSignal"
                    className={classes.signalDisplay}
                    style={{
                      color:
                        this.props.signalStatus === 'Excellent' ||
                          this.props.signalStatus === 'Good'
                          ? 'green'
                          : this.props.signalStatus === 'Paused'
                            ? 'gray'
                            : this.props.signalStatus === 'Calculating'
                              ? 'orange'
                              : this.props.signalStatus === 'Poor' ||
                                this.props.signalStatus === 'Fair' ||
                                this.props.signalStatus === 'Disconnected'
                                ? 'red'
                                : 'none',
                    }}
                  >
                    <div
                      className={classes.connColor}
                      style={{
                        background:
                          this.props.signalStatus === 'Excellent' ||
                            this.props.signalStatus === 'Good'
                            ? 'green'
                            : this.props.signalStatus === 'Calculating'
                              ? 'orange'
                              : this.props.signalStatus === 'Poor' ||
                                this.props.signalStatus === 'Fair' ||
                                this.props.signalStatus === 'Disconnected'
                                ? 'red'
                                : this.props.signalStatus === 'Paused'
                                  ? 'gray'
                                  : 'red',
                      }}
                    ></div>
                    {this.props.signalStatus !== 'N/A'
                      ? this.props.signalStatus
                      : 'N/A'}
                    <div style={{ float: 'right' }}>
                      {outOfHome}

                      <span
                        id="reportIDIssues"
                        className={classes.ReportButton}
                        onClick={this.showADIDIssuesForm}
                      >
                        Report ID Issues
                      </span>
                      {this.state.showADIDIssuesForm && (
                        <Modal
                          show={this.state.showADIDIssuesForm}
                          modalClosed={this.modalCancelHandlerForADIDIssuesForm}
                        >
                          <ReportADIDIssuesForm
                            closeModal={this.closeModalforADIDIssuesForm}
                            onCancel={this.modalCancelHandlerForADIDIssuesForm}
                            devMac={this.props.originalDevice.mac}
                            iconUrl={deviceIconUrl}
                            deviceModel={deviceModel}
                            deviceName={this.props.devName}
                          />
                        </Modal>
                      )}
                      <Modal
                        show={this.props.reportAdidIssueSuccess}
                        modalClosed={
                          this.successErrorResetHandlerForADIDIssueForm
                        }
                      >
                        <Success id={'DeviceSuccess'} />
                      </Modal>
                      <Modal
                        show={this.props.reportAdidIssueError}
                        modalClosed={
                          this.successErrorResetHandlerForADIDIssueForm
                          // this.ResetSteeringPollingExpiresAt && successErrorResetHandlerForADIDIssueForm
                        }
                      >
                        <Error id={'DeviceError'} />
                      </Modal>
                    </div>
                  </div>

                  <div className={classes.WifiSecurity}>
                    <span id='wpaSecurity' style={{ marginRight: '0.5em' }}><b>
                      {`WiFi Security: ${this.state.wifiSecurityMode}`}
                    </b></span>
                  </div>

                </div>
                {!this.state.featureFlags.includes('isVar') &&
                  <div
                    disabled={
                      this.props.deviceGroupName === 'Ungrouped' ||
                        this.props.deviceGroupName === 'UnGrouped'
                        ? false
                        : true
                    }
                    className={`${classes.deviceDiv} ${classes.toggleHolder}`}
                    style={
                      this.props.deviceGroupName === 'Ungrouped' ||
                        this.props.deviceGroupName === 'UnGrouped'
                        ? { background: 'none', padding: '12px' }
                        : {
                          background: 'none',
                          padding: '12px',
                          pointerEvents: 'none',
                          opacity: '0.5',
                          color: 'dimgrey',
                        }
                    }
                  >

                    <span style={{ padding: '5px' }}>
                      <b>Device Pause:</b>
                    </span>
                    {/* {console.log('>>>>cccaaa', this.state.checked, this.state.customTemp)} */}
                    <div style={{ padding: '3px' }}>
                      <Switch
                        id="DeviceManualToggle"
                        aria-checked={this.state.checked}
                        aria-label="Toggle device pause"
                        onText="ENABLED"
                        offText="DISABLED"
                        onChange={this.handleTogglePause}
                        checked={this.state.checked}
                      />
                    </div>
                  </div>}
              </div>
            </div>
            {speedBoostCheck}
            {(isDeviceSteeringWith5GOr6G || isTwoFourDeviceSteering) && this.state.featureFlags.includes('smartSteer') &&
              <DeviceSteeringtwoFour
                isDeviceSteeringtwoFour={isDeviceSteering}
                steering={this.props.originalDevice.steering}
                startSteering={this.props.startSteering}
                stopSteering={this.props.stopSteering}
                originalDevice={this.props.originalDevice}
                routerMac={this.props.routerMac}
                // isDisabled={this.props.originalDevice.freeze.frozen}
                expiresAt={this.props.pollingExpiresAt}
                isTwoFourSteeringEnabled={(!isTwoFourForcedSteering && !isDeviceSteeringWith5GOr6G)}
                // customTemp={this.state.customTemp}
                handleDeviceSteering={this.handleDeviceSteering}
                isDeviceSuspend={this.props.originalDevice.freeze.suspended.enable}
              />
            }
            <div className={classes.flexContainer}>
              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Pause State:</div>
                <div id="pauseState" style={{ color: '#666', flex: '1' }}>
                  {this.props.originalDevice &&
                    this.props.originalDevice.freeze &&
                    this.props.originalDevice.freeze.frozen
                    ?
                    'On'
                    : 'Off'}
                </div>
              </div>
              {!sessionStorage.getItem('type').includes('Business') &&
                <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                  <div style={{ flex: '1' }}>Group:</div>
                  <div style={{ color: '#666', flex: '1' }}>{groupInfoHtml}</div>
                </div>}
            </div>

            <div className={classes.flexContainer}>
              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Device Model:</div>
                <div id="deviceModal" style={{ color: '#666', flex: '1' }}>
                  {this.props.deviceModel ? this.props.deviceModel : 'N/A'}
                </div>
              </div>

              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Software Version:</div>
                <div id="softwareVersion" style={{ color: '#666', flex: '1' }}>
                  {this.props.softwareVersion
                    ? this.props.softwareVersion
                    : 'N/A'}
                </div>
              </div>
            </div>

            <div className={classes.flexContainer}>
              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Connected To:</div>
                <div id="connectedTo" style={{ color: '#666', flex: '1', whiteSpace: 'pre-wrap' }}>
                  <span className={classes.DeviceConnectedWrapping} style={{ whiteSpace: 'pre-wrap' }}>
                    {this.getConnectedTo()}
                  </span>
                </div>
              </div>

              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Connection:</div>
                <div id="connection" style={{ color: '#666', flex: '1' }}>
                  {freq}
                  {this.props.originalDevice.channel
                    ? '/' + this.props.originalDevice.channel
                    : ''}
                </div>
              </div>
            </div>

            <div className={classes.flexContainer}>
              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>
                  {this.props.originalDevice.connectionState === 'connected'
                    ? 'Connected Since:'
                    : 'Last Connected:'}
                </div>
                <div id="lastconnection" style={{ color: '#666', flex: '1' }}>
                  {moment(
                    this.props.originalDevice.connectionStateChangeAt
                  ).format('MM/DD/YY, h:mm a')}
                </div>
              </div>

              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Initial Connection:</div>
                <div id="initialconnected" style={{ color: '#666', flex: '1' }}>
                  {moment(this.props.originalDevice.firstConnectedAt).format(
                    'MM/DD/YY, h:mm a'
                  )}
                </div>
              </div>
            </div>

            <div className={classes.flexContainer}>
              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>IP Address:</div>
                <div id="ipaddress" style={{ color: '#666', flex: '1' }}>
                  {this.props.originalDevice.ip
                    ? this.props.originalDevice.ip
                    : 'N/A'}
                </div>
              </div>

              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>MAC Address:</div>
                <div id="DeviceMacAddress" style={{ color: '#666', flex: '1' }}>
                  {this.props.originalDevice.mac}
                </div>
              </div>
            </div>

            <div className={classes.flexContainer}>
              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Connection Type:</div>
                <div id="devicetype" style={{ color: '#666', flex: '1' }}>
                  {this.props.originalDevice.connectionState === 'disconnected'
                    ? 'N/A'
                    : this.props.originalDevice.medium
                      ? this.props.originalDevice.medium
                      : 'N/A'}
                </div>
              </div>
              <div className={classes.flexContainer} style={{ flex: '1 1' }}>
                <div style={{ flex: '1' }}>Max WiFi Speed:</div>
                <div id="maxwifispeed" style={{ color: '#666', flex: '1' }}>
                  {wifiMaxSpeed}
                </div>
              </div>
            </div>
          </div>
          {capabilities6g}
          {capabilities}
          {capabilities1}
          {interferenceSection}
          {
            !sessionStorage.getItem('featureFlags')?.includes('isVar') &&
            <div className={classes.showDesktop}>
              <h4
                id="SchedulePauseText"
                style={{ margin: '20px 15px 15px 14px' }}
              >
                Scheduled Pause
              </h4>
              {schedulePauseButtonHtml}
            </div>
          }
          {!sessionStorage.getItem('featureFlags')?.includes('isVar') &&

            <div className={classes.showMobile}>
              <h4 style={{ margin: '20px 15px 15px 14px' }}>Scheduled Pause</h4>

              {mobileSchedulePauseButtonHtml}

            </div>
          }
          <QOE
            selectedEquipment={this.props.selectedEquipment}
            devMac={this.props.originalDevice.mac}
            freq={this.props.originalDevice.medium}
            connectionState={this.props.originalDevice.connectionState}
          ></QOE>
          {advancedDevice}
          <div style={{ height: '85px' }}></div>
        </div>
        <Modal
          editDevName="true"
          show={this.state.showEditDevName}
          modalClosed={this.confirmModalCancelHandler}
        >
          <h3
            className={classes.RegularButton}
            style={{ marginTop: '2px' }}
            onClick={this.backToDeviceOverview}
          >
            {'<'} Back To Device Overview
          </h3>
          <div className={classes.Separator} />
          {showDeviceEditModal}
        </Modal>
        <Modal
          show={this.state.confirmModal}
          modalClosed={this.confirmModalCancelHandler}
        >
          <Confirm
            id={'DeviceConfirm'}
            confirmMsgStyling={confirmMsgStyling}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            action={typeof confirmAction == 'string' ? `Are you sure you want to ${confirmAction}?` : confirmAction}
            deviceGroupConfirmation
          />
        </Modal>
        {/* {this.state.steeringDevices && (
          <Modal
            id={leftOutTime === '60' ? 'FeaturePauseEnable' : 'PauseEnabeling' }
            deviceGroupConfirmation="true"
            show={this.state.steeringDevices}
            modalClosed={this.closeScheduleSteeringMessageModal}
          >
            <div>
              <div style={{ display: 'flex', flexDirection: 'column', padding: '25px 5px 5px 5px' }}>
                <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  <FaExclamationTriangle
                    id = 'DSAlertIcon'
                    color={'red'}
                    fontSize={'35px'}
                    style={{ marginRight: '5px', marginTop: '8px' }} />
                    <h2>Error</h2>
                </div>

                <p id ='DSDeviceModalAlertText' style={{ fontWeight: 'normal' }}>
                  {
                   leftOutTime === '60' ?
                   'The selected smartphone/tablet is paused or will begin a scheduled pause in the next 60 minutes and must be un-paused or the pause schedule modified to be used for 2.4GHz.'
                    : <Box>The selected smartphone/tablet has been steered and must not be paused or scheduled to begin a scheduled pause in the next {leftOutTime} minutes.</Box>
                  }

                </p>
              </div>
              <button className={classes.DeviceSteeringRegularButton} onClick={this.closeScheduleSteeringMessageModal}>
                OK
              </button>
            </div>
          </Modal>
        )
        } */}

      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    secondSsid: state.secondSsid,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    isDummy: state.auth.isDummy,
    claimedPods: state.equipment.realEquipment
      ? state.equipment.realEquipment.claimedPods
      : [],
    realWan: state.wan.realWan,
    reportAdidIssueError: state.devices.reportAdidIssueError,
    reportAdidIssueSuccess: state.devices.reportAdidIssueSuccess,
    speedBoostDevices: state.speedBoost.speedBoostDevices,
    speedBoostDevicesLoading: state.speedBoost.speedBoostDevicesLoading,
    routerMac: state.wan.realWan.id,
    pollingExpiresAt: state.deviceSteering.pollingExpiresAt,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeDeviceName: (deviceName, deviceIcon, devMac, selectedEquipment) =>
      dispatch(actions.changeDeviceName(deviceName, deviceIcon, devMac, selectedEquipment)),
    onChangeDeviceIcon: (deviceName, deviceIcon, devMac, selectedEquipment) =>
      dispatch(actions.changeDeviceIcon(deviceName, deviceIcon, devMac, selectedEquipment)),
    onChangePauseDevice: (newVal, devMac, selectedEquipment) =>
      dispatch(actions.changePauseDevice(newVal, devMac, selectedEquipment)),
    onChangeFreezeDevice: (putDelete, devMac, templateID, template, selectedEquipment) => {
      dispatch(
        actions.changeFreezeDevice(putDelete, devMac, templateID, template, selectedEquipment)
      );
    },
    onRefreshDevices: () => dispatch(actions.refreshDevices()),
    onDeleteDevice: (devMac) => dispatch(actions.deleteDevice(devMac)),
    onGetAdvancedDevice: (deviceMac, days) =>
      dispatch(actions.getAdvancedDevice(deviceMac, days)),
    onSetSelectedEquipment: (equipment) => {
      dispatch(actions.setSelectedEquipment(equipment));
    },
    onResetAdidIssueErrorSuccess: () => {
      dispatch(actions.resetAdidIssueErrorSuccess());
    },
    getSpeedBoostCheckDevices: () => {
      dispatch(actions.getSpeedBoostCheckDevices());
    },
    startSteering: (action) => {
      dispatch(actions.startSteering(action))
    },
    stopSteering: (action) => {
      dispatch(actions.stopSteering(action))
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(DeviceDetails, api));
